import {
    BookIcon,
    CalendarIcon,
    CalculatorIcon,
    ChartBarIcon,
    FileTextIcon,
    GaugeIcon,
    InfoIcon,
    LayersIcon,
    LineChartIcon,
    PercentIcon,
    WalletIcon,
} from "lucide-react";
import { NavSection } from "@/lib/shadcn/components/sidebar/nav-platform";

export const demoSidebarItems: NavSection[] = [
    {
        title: "Platform",
        items: [
            {
                title: "Reports",
                url: "/demo/reports",
                icon: FileTextIcon,
            },
            {
                title: "Reservations",
                url: "/demo/reservations",
                icon: BookIcon,
            },
            {
                title: "Calendar",
                url: "/demo/calendar",
                icon: CalendarIcon,
            },
            {
                title: "Expenses",
                url: "/demo/expenses",
                icon: WalletIcon,
            },
            {
                title: "Trends",
                url: "/demo/trends",
                icon: LineChartIcon,
            },
            {
                title: "Trend Graphs",
                url: "/demo/graphs/apartments",
                icon: ChartBarIcon,
            },
            {
                title: "Aggregate Expenses",
                url: "/demo/aggregate-expenses",
                icon: CalculatorIcon,
            },
            {
                title: "Booking Pace",
                url: "/demo/owner-booking-pace",
                icon: GaugeIcon,
            },
            {
                title: "Occupancy Explorer",
                url: "/demo/owner-occupancies",
                icon: PercentIcon,
            },
            {
                title: "BLT Breakdown",
                url: "/demo/owner-blt",
                icon: LayersIcon,
            },
        ],
    },
    {
        title: "Info",
        items: [
            {
                title: "Payout Mechanism",
                url: "/demo/payout-mechanism",
                icon: InfoIcon,
            },
        ],
    },
];
